<template>
  <nav></nav>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "PageNav",
  computed: {
    ...mapState("User", ["user"]),
    ...mapGetters("User", ["isAdmin", "isUser"])
  }
};
</script>
